import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { ExpandLess, ExpandMore, StyleSharp } from '@mui/icons-material';
import NavItem from '../NavItem';
import { NavegableItem } from '../../../contexts/NavigationContext';
import useStyles from './styles';

export interface NavItemBase {
  icon: JSX.Element;
  title: string;
  active?: boolean;
  disabled?: boolean;
}

export interface NavItemLink extends NavItemBase {
  to: string;
}

export interface NavItemGroup extends NavItemBase {
  items: NavItemLink[];
}

export function isNavGroup(item: NavegableItem): item is NavItemGroup {
  return 'items' in item;
}

export const NavGroup = ({ icon, title, items, active, disabled }: NavItemGroup): JSX.Element => {
  const [open, setOpen] = useState(active || false);
  const styles = useStyles();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleClick = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <div>
      <ListItemButton className={styles.listItem} onClick={handleClick} disabled={disabled} selected={active}>
        <ListItemIcon className={styles.icon}>{icon}</ListItemIcon>
        <ListItemText
          primary={
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {title}
              {open ? <ExpandLess /> : <ExpandMore />}
            </div>
          }
        />
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding className={styles.items}>
          {items.map((item) => (
            <NavItem {...item} key={item.title} active={pathname === item.to!} onClick={() => navigate(item.to!)} />
          ))}
        </List>
      </Collapse>
    </div>
  );
};
